import { ConfirmDialog } from "primereact/confirmdialog"
import styles from "../../styles/Participant-GPRA.module.css"
const EditConfigDialog = ({ show, setShow, accept, reject }) => {
  return (
    <ConfirmDialog
      visible={show}
      group="declarative"
      onHide={() => setShow(false)}
      icon="pi pi-exclamation-triangle"
      accept={accept}
      reject={reject}
      message={
        <>
          <label
            className={`${styles.editConfirmationLabel} ${styles.editConfirmationTitle}`}
          >
            Changes made during an interview edit are saved automatically and
            cannot be undone, please proceed with caution.
          </label>
          <label className={styles.editConfirmationLabel}>
            Are you sure you want to edit this GPRA interview?
          </label>
        </>
      }
    />
  )
}
export default EditConfigDialog
